import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const eventCardStyles = (
	theme: Theme,
	adaptiveWidth?: boolean,
	backgroundUrl?: string,
) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		aspectRatio: '1/1.32',
		position: 'relative',
		overflow: 'hidden',
		borderRadius: '3px',

		width: '100%',
		minWidth: { xs: '240px', md: '300px', lg: '420px' },
		maxWidth: adaptiveWidth ? { xs: '420px' } : { xs: '240px', md: '300px', lg: '420px' },
	},
	bgImage: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		objectPosition: 'center',
		backgroundColor: 'black',
		zIndex: -1
	},
	flexRow: {
		display: 'flex',
		flexDirection: 'row',
	},
	flexColumn: {
		display: 'flex',
		flexDirection: 'column',
	},
	badgesRow: {
		p: { xs: '12px', md: '16px', lg: '20px' },
	},
	infoSection: {
		gap: { xs: '6px', md: '10px', lg: '14px' },
		mt: 'auto',
		color: 'white',
		background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 56.22%, #000000 100%)',
		p: { xs: '12px', md: '16px', lg: '20px' },
	},
	instanceRow: {
		display: 'flex',
		alignItems: 'center',
		color: 'white',
		gap: '8px',
	},
	instanceIcon: {
		width: '24px',
		height: '24px',
	},
	instanceText: {
		fontSize: { xs: '12px', s: '14px', md: '16px', lg: '18px' },
		lineHeight: '20px',
		fontWeight: '400',
		textTransform: 'uppercase',
		fontFamily: 'Integral CF',
		textShadow: '1px 1px 2px black',
	},
	eventNameText: {
		fontSize: { xs: '14px', s: '16px', md: '22px', lg: '28px' },
		lineHeight: '32px',
		fontWeight: '700',
		textTransform: 'uppercase',
		fontFamily: 'Integral CF',
		whiteSpace: 'wrap',
		overflow: 'hidden',
		textShadow: '1px 1px 2px black',
	},
	buttonsSection: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxWidth: '100%',
		overflow: 'hidden',
		gap: '16px',
	},
	authorRow: {
		alignItems: 'center',
		gap: { xs: '5px', md: '8px' },
		overflow: 'hidden',
		flex: 1,
	},
	eventAuthorText: {
		fontSize: { xs: '12px', md: '16px' },
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		flex: 1,
	},
	joinButton: {
		textTransform: 'uppercase',
		color: 'white',
		border: '1px solid white',
		borderRadius: '100px',
		p: { xs: '2px 4px', s: '4px 8px', md: '8px 16px', lg: '16px 32px' },
		background: 'transparent',

		'&:hover': {
			color: Colors['120E0D'],
			backgroundColor: 'white',
		},
	},
	joinButtonText: {
		fontFamily: 'Integral CF',
		fontWeight: '500',
		fontSize: { xs: '12px', s: '14px', md: '16px', lg: '18px' },
		lineHeight: { xs: '14px', md: '16px', lg: '20px' },
	},
	skeletonRoot: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	}
});
